<template>
    <v-img v-if="treeSrc != '' && treeSrc != undefined" :src="getImage(treeSrc)" contain :width="width" :height="height"></v-img>
    <svg v-else id="그룹_15799" data-name="그룹 15799" xmlns="http://www.w3.org/2000/svg" width="149.745" height="175.405" viewBox="0 0 149.745 175.405">
      <path id="패스_868" data-name="패스 868" d="M254.758,737.959a33.472,33.472,0,0,0-31.6-39.315,33.508,33.508,0,0,0-65.051,11.305c0,.267.014.529.02.795a33.505,33.505,0,0,0-13.878,21.4A33.5,33.5,0,1,0,173.2,792.38a33.49,33.49,0,0,0,49.05,4.144,33.5,33.5,0,1,0,32.508-58.566Z" transform="translate(-123.058 -676.443)" fill="#98bb52"/>
      <g id="그룹_15798" data-name="그룹 15798" transform="translate(55.319 79.77)">
        <path id="패스_869" data-name="패스 869" d="M261.08,943.357h29.685L280.327,859.85H270.275Z" transform="translate(-256.369 -859.85)" fill="#69492b"/>
        <path id="패스_870" data-name="패스 870" d="M321.459,890.961l1.418,1.8-13.66,19.588-1.418-12.5Z" transform="translate(-282.769 -877.43)" fill="#69492b"/>
        <path id="패스_871" data-name="패스 871" d="M252.053,928.924l-1.8,1.546,9.694,13.918,1.647-9.021Z" transform="translate(-250.249 -898.882)" fill="#69492b"/>
      </g>
      <ellipse id="타원_735" data-name="타원 735" cx="4.215" cy="4.215" rx="4.215" ry="4.215" transform="translate(96.997 61.379)" fill="#ffe600"/>
      <ellipse id="타원_736" data-name="타원 736" cx="4.215" cy="4.215" rx="4.215" ry="4.215" transform="translate(28.262 79.598)" fill="#ffe600"/>
      <ellipse id="타원_737" data-name="타원 737" cx="4.215" cy="4.215" rx="4.215" ry="4.215" transform="translate(51.974 61.379)" fill="#ffe600"/>
      <ellipse id="타원_738" data-name="타원 738" cx="4.215" cy="4.215" rx="4.215" ry="4.215" transform="translate(63.827 32.77)" fill="#ffe600"/>
      <ellipse id="타원_739" data-name="타원 739" cx="4.215" cy="4.215" rx="4.215" ry="4.215" transform="translate(116.297 88.029)" fill="#ffe600"/>
      <path id="패스_872" data-name="패스 872" d="M185.459,1060.147c0-8.327,21.595-15.078,48.233-15.078s48.233,6.751,48.233,15.078Z" transform="translate(-158.319 -884.742)" fill="#98bb52"/>
    </svg>
</template>

<script>
export default {
  props: {
    treeSrc: String,
    width: {
      type: String,
      default: '149.745'
    },
    height: {
      type: String,
      default: '175.405'
    }
  }
}
</script>